module.exports = __webpack_public_path__ + "img/alper-logo-menu.c92bf93c.png";